import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Input, Button } from 'reactstrap';
import DatePicker from 'react-datepicker';
// import { FaCalendarAlt } from 'react-icons/fa';
import { connect } from 'react-redux';
import UpdateProjectDetailsService from '../../../../../Service/DashboardServices/ProjectsDashboard/UpdateProjectDetailsService';
import { FaCalendarAlt } from 'react-icons/fa';
import FetchCMProductDataService from '../../../../../Service/DashboardServices/ContentManagementServices/FetchCMProductDataService';
import CustomModal from '../../../../Components/Modals/CustomModal';
import NewProjectProductList from '../Scenes/SidebarComponents/NewProjectProductList';
import NewTaskIcon from '../../../../../designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg';
import ReactQuill from 'react-quill';
import { Editor, SetInnerHtmlWithClassReplacement } from "../../../../../Utils/Constants";

function UpdateProjectDetails(props) {

    const [loading, setLoading] = useState(false);
    const [addProductsPopup, setAddProductsPopup] = useState(false)
    const [productList, setProductList] = useState()
    const [asinList, setAsinList] = useState(null);
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [duplicateProjects, setDuplicateProjects] = useState([]);
    const [text, setText] = useState('');

  // Store original data for comparison
    const [originalData, setOriginalData] = useState({});
    const [newFormData, setNewFormData] = useState({
        id: props.projectDetailsForEdit.projectId,
        ownerId: props.projectDetailsForEdit.ownerId,
        graphicDesignerId: props.projectDetailsForEdit.graphicDesignerId,
        projectName: props.projectDetailsForEdit.projectName || props.projectDetailsForEdit.name,
        projectOwner: props.projectDetailsForEdit.owner,
        graphicDesigner: props.projectDetailsForEdit.graphicDesigner,
        dueDate: props.projectDetailsForEdit.dueDate,
        startDate: props.projectDetailsForEdit.startDate,
        brandId: props.projectDetailsForEdit.brandId,
        action: 'false',
        asin: props.projectDetailsForEdit.asin,
        asinList: Array.isArray(props.projectDetailsForEdit.asin) ? props.projectDetailsForEdit.asin : props.projectDetailsForEdit.asin ? [props.projectDetailsForEdit.asin] : []
    });
    // Helper to normalize asin prop into array of trimmed ASINs
    const getAsinArray = (asin) => {
        if (!asin) return [];
        if (Array.isArray(asin)) return asin;
        return asin
            .toString()
            .split(',')
            .map(s => s.trim())
            .filter(Boolean);
    };

    // Helper function to normalize dates for comparison
    const normalizeDateForComparison = (date) => {
        if (!date) return null;
        if (date instanceof Date) {
            return date.toISOString().split('T')[0];
        }
        return new Date(date).toISOString().split('T')[0];
    };
    useEffect(() => {
        if (props.projectDetailsForEdit) {
            // Handle note/description
            const initialNote = props.projectDetailsForEdit.note || props.projectDetailsForEdit.description || "";
            setText(initialNote);
    
            // Handle asin list
            const existingAsins = getAsinArray(props.projectDetailsForEdit.asin);
            const normalizedAsins = Array.from(new Set(existingAsins.map(String)));
            setAsinList(normalizedAsins);
    
            // Set original data for comparison
            setOriginalData({
                ownerId: props.projectDetailsForEdit.ownerId,
                graphicDesignerId: props.projectDetailsForEdit.graphicDesignerId,
                projectName: props.projectDetailsForEdit.projectName || props.projectDetailsForEdit.name,
                brandId: props.projectDetailsForEdit.brandId,
                dueDate: props.projectDetailsForEdit.dueDate,
                startDate: props.projectDetailsForEdit.startDate,
                asin: normalizedAsins
            });
        }
    }, [props.projectDetailsForEdit]);

    useEffect(() => {
        setNewFormData(prev => ({
            ...prev,
            asin: Array.isArray(asinList) ? asinList : [asinList],
            asinList: Array.isArray(asinList) ? asinList : [asinList]
        }));
    }, [asinList]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewFormData({
            ...newFormData,
            [name]: value,
        });
    };

    const hasFormChanged = () => {
        // Wait for original data to be set
        if (!originalData.ownerId && originalData.ownerId !== '' && originalData.ownerId !== null) {
            return false;
        }
        // Compare basic fields - handle null/undefined values
        if ((newFormData.ownerId || '') !== (originalData.ownerId || '')) return true;
        if ((newFormData.graphicDesignerId || '') !== (originalData.graphicDesignerId || '')) return true;
        if ((newFormData.projectName || '') !== (originalData.projectName || '')) return true;
        if ((newFormData.brandId || '') !== (originalData.brandId || '')) return true;
        if ((text || '').trim() !== (props.projectDetailsForEdit.description || '').trim()) return true;
        // Compare dates
        const newStartDate = normalizeDateForComparison(newFormData.startDate);
        const originalStartDate = normalizeDateForComparison(originalData.startDate);
        if (newStartDate !== originalStartDate) return true;

        const newDueDate = normalizeDateForComparison(newFormData.dueDate);
        const originalDueDate = normalizeDateForComparison(originalData.dueDate);
        if (newDueDate !== originalDueDate) return true;

        // Compare ASINs
        const currentAsin = Array.isArray(asinList) ? [...asinList].sort() : [];
        const originalAsin = Array.isArray(originalData.asin) ? [...originalData.asin].sort() : [];
        
        if (currentAsin.length !== originalAsin.length) return true;
        for (let i = 0; i < currentAsin.length; i++) {
            if (String(currentAsin[i]).trim() !== String(originalAsin[i]).trim()) return true;
        }

        return false;
    };

    const handleSelectProduct = () => {
        let data = {
            asinList:'',
            integerID: props.projectDetailsForEdit.integerId,
            fetchAll: true,
            projectId:0,
        }
        FetchCMProductDataService(props.token, data).then((res) => {
            if (res) {
                console.log(res)
                setProductList(res.productsList)
                setAddProductsPopup(true)
            }
        })
    }
    const checkForDuplicateProjects = () => {
        const duplicateProjects = props.projectDetailsList.filter(project =>
            project.accountId === parseInt(props.projectDetailsForEdit.accountId) &&
            project.integerId === parseInt(props.projectDetailsForEdit.integerId) &&
            project.brandId === parseInt(newFormData.brandId) &&
            project.workflowsId === parseInt(props.projectDetailsForEdit.workflowsId) &&
            project.projectId !== props.projectDetailsForEdit.projectId // Exclude current project
        );

        if (duplicateProjects.length > 0) {
            // Store all duplicate project details
            setDuplicateProjects(duplicateProjects);
            setShowConfirmationPopup(true);
            return true; // Has duplicates
        }
        return false; // No duplicates
    };
    const handleBrandChange = (e) => {
        const brandId = e.target.value;
        const selectedText =
    e.target.options &&
    e.target.options[e.target.selectedIndex] &&
    e.target.options[e.target.selectedIndex].text;

    
        const brandName =
            brandId && selectedText !== "Select Brand"
                ? selectedText
                : null;
    
        setNewFormData(prev => ({
            ...prev,
            brandId,
            brandName, 
        }));
    };
    
    const saveProject = () => {
        if (props.projectDetailsForEdit.startDate instanceof Date) {
            props.projectDetailsForEdit.startDate = props.projectDetailsForEdit.startDate.toISOString().split('T')[0];
        }
        const updatedData = {
            ...newFormData,
            description: text,
            projectId:props.projectDetailsForEdit.projectId,  
          };
        setLoading(true);
        UpdateProjectDetailsService(props.token, updatedData).then((res) => {
            setLoading(false);
            if (res) {
                console.log(res)
                props.setOpenProjectEditPopup(false)
                props.setProjectDetailsList(res.ProjectDetailsList)
            }
        });
    };
    const hasBrandChanged = () => {
        return (newFormData.brandId || '') !== (originalData.brandId || '');
    };
    const handleSubmitEditInfo = () => {
        if (!hasFormChanged()) return;
        // Check for duplicates first
        if (hasBrandChanged() && checkForDuplicateProjects()) {
            return; // Stop here if duplicates found, popup will show
        }
        // If no duplicates, proceed with saving
        saveProject();
    };
    const handleConfirmDuplicate = () => {
        setShowConfirmationPopup(false);
        saveProject(); 
    };

    const handleCancelDuplicate = () => {
        setShowConfirmationPopup(false);
        // User canceled, don't save
    };
    return (
        <>
            <Col className='mb-4'>
                <Row className='ml-3'>
                    <Col md={6} className='mt-1'>
                        <label><h6><b>Project Name : </b></h6></label>
                        <Input
                            name="projectName"
                            className='create-new-project-width'
                            value={newFormData.projectName || ''}
                            onChange={handleChange}
                        />
                    </Col>
                    <Col md={6}>
                        <label><h6><b>Account Name : </b></h6></label>
                        <Input
                            type='text'
                            className='create-new-project-width'
                            value={props.projectDetailsForEdit.accountName}
                            disabled
                        />
                    </Col>
                    <Col md={6} className='mt-3'>
                        <label><h6><b>Store Name : </b></h6></label>
                        <Input
                            type='text'
                            className='create-new-project-width'
                            value={props.projectDetailsForEdit.storeName}
                            disabled
                        />
                    </Col>
                    <Col md={6} className='d-flex mt-3'>
                        <div><h6><b>ASIN List :</b></h6>
                            <div style={{
                                maxHeight: '60px',
                                overflowY: 'auto',
                            }}>
                                {Array.isArray(asinList) ? (
                                    asinList.map((asin, index) => {
                                        const product = productList && productList.find(p => p.asin === asin);
                                        return (
                                            <span
                                                key={index}
                                                title={product && product.productTitle || product && product.name || ''}
                                            >
                                                {asin}
                                                {index < asinList.length - 1 ? ', ' : ''}
                                            </span>
                                        );
                                    })
                                ) :
                                    <div >
                                        {getAsinArray(props.projectDetailsForEdit.asin).map((a, i, arr) => (
                                            <div key={i}>
                                                {a}
                                                {i < arr.length - 1 ? ',' : ''}
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                        <Col md={6} className='ml-5'>
                            <div className='=mt-3'>
                                <Button
                                    className="btn-background-color w-100 mt-2"
                                    onClick={() => { handleSelectProduct() }}
                                    disabled={!props.projectDetailsForEdit.storeName}
                                >
                                    Add ASINs
                                    <img className='ml-2 mb-1' src={NewTaskIcon} style={{ height: '18px' }} />
                                </Button>
                            </div>
                        </Col>
                    </Col>

                    <Col md={6} className='mt-3'>
                        <label><h6><b>Brand : </b></h6></label>
                        <select
                            name="brandId"
                            className="form-control create-new-project-width"
                            value={newFormData.brandId}
                            onChange={handleBrandChange}   
                        >
                            <option value="">Select Brand</option>
                            {props.brandList &&
                                props.brandList
                                    .filter(brand =>
                                        !props.projectDetailsForEdit.integerId ||
                                        brand.integerId === parseInt(props.projectDetailsForEdit.integerId)
                                    )
                                    .map((brand) => (
                                        <option key={brand.id} value={brand.id}>
                                            {brand.brandName}
                                        </option>
                                    ))}
                        </select>
                    </Col>
                    <Col md={6} className='mt-3'>
                        <label><h6><b>WorkFlow : </b></h6></label>
                        <Input
                            type='text'
                            className='create-new-project-width'
                            value={props.projectDetailsForEdit.workflow}
                            disabled
                        />
                    </Col>
                    <Col md={6} className='mt-3'>
                        <label><h6><b>Project Owner : </b></h6></label>
                        <select
                            name="ownerId"
                            className="form-control create-new-project-width"
                            value={newFormData.ownerId}
                            onChange={handleChange}
                        >
                            <option disabled value="">Select Project Owner</option>
                            {props.ownerList && props.ownerList.map((Owner) => (
                                <option key={Owner.employeeId} value={Owner.employeeId}>
                                    {Owner.employeeName}
                                </option>
                            ))}
                        </select>
                    </Col>

                    <Col md={6} className='mt-3'>
                        <label><h6><b>Graphic Designer : </b></h6></label>
                        <select
                            name="graphicDesignerId"
                            className="form-control create-new-project-width"
                            value={newFormData.graphicDesignerId ? newFormData.graphicDesignerId : ''}
                            onChange={handleChange}
                        >
                            <option disabled value="">Select Graphic Designer</option>
                            {props.graphicDesignerList && props.graphicDesignerList.map((designer) => (
                                <option key={designer.id} value={designer.id}>
                                    {designer.name}
                                </option>
                            ))}
                        </select>
                    </Col>
                    <Col md={6} className="text-end mt-3">
                        <label><h6><b>Start Date : </b></h6></label>
                        <div className="position-relative picker-date-width">
                        <DatePicker
                                selected={newFormData.startDate ? new Date(newFormData.startDate) : null}
                                onChange={(date) => {
                                    if (date) {
                                        // Format as YYYY-MM-DD string
                                        const year = date.getFullYear();
                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                        const day = String(date.getDate()).padStart(2, '0');
                                        const dateString = `${year}-${month}-${day}`;
                                        
                                        setNewFormData(prevState => ({ 
                                            ...prevState, 
                                            startDate: dateString 
                                        }));
                                    } else {
                                        setNewFormData(prevState => ({ 
                                            ...prevState, 
                                            startDate: null 
                                        }));
                                    }
                                }}
                                placeholderText="Select start date"
                                className="form-control"
                                // Add these props to ensure DatePicker is independent
                                id="startDatePicker"
                                name="startDate"
                                />
                            <div className="calendar-icon-wrapper">
                                <FaCalendarAlt className="calendar-icon" />
                            </div>
                        </div>
                    </Col>
{/* 
                    <Col md={6} className='mt-3'>
                        <label><h6><b>Due Date : </b></h6></label>
                        <div className="position-relative picker-date-width">
                            <DatePicker
                                selected={newFormData.dueDate ? new Date(newFormData.dueDate) : null}
                                onChange={(date) =>
                                    setNewFormData({ ...newFormData, dueDate: date })
                                }
                                placeholderText="Select Due date"
                                className="form-control"
                            />
                        </div>
                    </Col> */}
                    <Col md={6} className='mt-3'>
                        <label><h6><b>Due Date : </b></h6></label>
                        <div className="position-relative picker-date-width">
                        <DatePicker
                                selected={newFormData.dueDate ? new Date(newFormData.dueDate + 'T00:00:00') : null}
                                onChange={(date) => {
                                    if (date) {
                                        // Format as YYYY-MM-DD string
                                        const year = date.getFullYear();
                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                        const day = String(date.getDate()).padStart(2, '0');
                                        const dateString = `${year}-${month}-${day}`;
                                        
                                        setNewFormData(prevState => ({ 
                                            ...prevState, 
                                            dueDate: dateString 
                                        }));
                                    } else {
                                        setNewFormData(prevState => ({ 
                                            ...prevState, 
                                            dueDate: null 
                                        }));
                                    }
                                }}
                                placeholderText="Select Due date"
                                className="form-control"
                                // Add these props to ensure DatePicker is independent
                                id="dueDatePicker"
                                name="dueDate"
                                filterDate={(date) => {
                                    if (newFormData.startDate) {
                                        const startDate = new Date(newFormData.startDate + 'T00:00:00');
                                        return date >= startDate;
                                    }
                                    if (props.projectDetailsForEdit && props.projectDetailsForEdit.startDate) {
                                        const startDate = new Date(props.projectDetailsForEdit.startDate + 'T00:00:00');
                                        return date >= startDate;
                                    }
                                    return true;
                                }}
                            />
                                <div className="calendar-icon-wrapper">
                                    <FaCalendarAlt className="calendar-icon" />
                                </div>
                            </div>
                        </Col>
                        <Col md={12} className='mt-3'>
                        <label><h6><b>Note : </b></h6></label>
                        <ReactQuill
                            theme="snow"
                            modules={Editor.modules}
                            formats={Editor.formats}
                            value={text}
                            onChange={setText}
                            bounds={'.quill-prod'}
                            placeholder='Add Your Comments Here'
                        />
                        </Col>
                </Row>
            </Col>

            <Col md={12} className='mt-5 d-flex justify-content-center'>
                <Button
                    className="btn-background-color"
                    onClick={handleSubmitEditInfo}
                    disabled={!hasFormChanged() || loading}
                >
                    {loading ? 'Updating...' : 'Update'}
                </Button>
            </Col>
            {/* Duplicate Project Confirmation Popup */}
                <CustomModal
                header= {'Duplicate Project Warning'}
                isOpen={showConfirmationPopup}
                toggle={() => setShowConfirmationPopup(false)}
                size={"md"}
                className='curve-popup'
            >
                <div className="p-3">
                    <p className="mb-3">
                    One or more projects with the same Account, Store, Brand, and Workflow combination already exist:
                    </p>
                    
                    {duplicateProjects && duplicateProjects.length > 0 && (
                        <div className="mb-3">
                            <strong>Existing Projects:</strong>
                            <ul className="mt-2">
                                {duplicateProjects.map((proj, index) => (
                                    <li key={index} className="mb-1">
                                        Project ID: {proj.projectId} | Name: {proj.projectName}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    
                    <p className="mb-4">
                        Are you sure you want to update this project? 
                    </p>
                    
                    <div className='mb-2 d-flex justify-content-end mr-2'>
                        <Button 
                            className="me-2 no-btn-background-color" 
                            onClick={handleCancelDuplicate}
                        >
                            Cancel
                        </Button> &nbsp;
                        <Button 
                            // color="primary" 
                            className='btn-background-color'
                            onClick={handleConfirmDuplicate}
                            style={{ marginLeft: "10px" }}
                            disabled={loading}
                        >
                            {loading ? 'Proceeding...' : 'Proceed'}
                        </Button>
                    </div>
                </div>
            </CustomModal>
            
            <CustomModal
                header={
                    <span>
                        Add ASINs for : <b>{props.projectDetailsForEdit.storeName || ''}</b>
                    </span>
                }
                isOpen={addProductsPopup}
                toggle={() => {
                    setAddProductsPopup(!addProductsPopup);
                }}
                size={"lg"}
                className='my-task-custom-module'
            >
                <NewProjectProductList
                    setAddProductsPopup={setAddProductsPopup}
                    asinList={asinList}
                    setAsinList={setAsinList}
                    productList={productList}
                />
            </CustomModal>
        </>
    );
}

const mapStateToProps = state => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        status: state.loggedUser.status,
    }
}

export default connect(mapStateToProps)(UpdateProjectDetails);